export enum ExtractedUserMetaType {
  EXTRACTED_USER_RESIDUAL_BENEFICIARY_META = 'ExtractedUserResidualBeneficiaryMeta',
  EXTRACTED_USER_SPECIFIC_BENEFICIARY_META = 'ExtractedUserSpecificBeneficiaryMeta'
}
